export default "__VITE_ASSET__DXYC6z_o__"